<template>
  <div class="pagination">
    <nav class="pagination-nav">
      <ul class="pagination-nav-list">
        <li v-if="showFirst" class="pagination-nav-list-item first">
          <span class="pagination-nav-list-item-content" @click="$emit('onPaginate', 1)"> 1 </span>
          <span class="mr-2"> ... </span>
        </li>
        <li
          v-for="(page, index) in visiblePages"
          :key="`page-${index}`"
          class="pagination-nav-list-item"
        >
          <span
            class="pagination-nav-list-item-content"
            :class="[isCurrentPage(page) && 'bg-ricoma-orange-200 text-white']"
            @click="$emit('onPaginate', page)"
          >
            {{ page }}
          </span>
        </li>
        <li v-if="showLast" class="pagination-nav-list-item last">
          <span> ... </span>
          <span class="pagination-nav-list-item-content" @click="$emit('onPaginate', totalPages)">
            {{ totalPages }}
          </span>
        </li>
      </ul>
    </nav>
    <button
      class="pagination-button left"
      :class="[!hasPrev && 'text-ricoma-gray-500']"
      :disabled="!hasPrev"
      @click="$emit('onPaginate', currentPage > 1 && currentPage - 1)"
    >
      <VSvgIcon name="arrow-left" class="h-5" />
      {{ $t('pagination.prev') }}
    </button>
    <button
      class="pagination-button right"
      :class="[!hasNext && 'text-ricoma-gray-500']"
      :disabled="!hasNext"
      @click="handleClickPage(currentPage < totalPages && currentPage + 1)"
    >
      {{ $t('pagination.next') }}
      <VSvgIcon name="arrow-right" class="h-5" />
    </button>
  </div>
</template>

<script>
import VSvgIcon from '@/components/base/VSvgIcon';

export default {
  name: 'Pagination',
  components: { VSvgIcon },
  props: {
    totalPages: {
      type: Number,
      default: 1,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    visiblePages() {
      if (this.totalPages < 6) {
        return [...Array(this.totalPages)].map((_, i) => i + 1);
      }

      if (this.currentPage < 6) {
        return [...Array(6)].map((_, i) => i + 1);
      }

      if (this.totalPages - this.currentPage < 5) {
        return [...Array(6)].map((_, i) => this.totalPages - 6 + i + 1);
      }

      return [...Array(3)].map((_, i) =>
        i === 0 ? this.currentPage - 1 : i === 2 ? this.currentPage + 1 : this.currentPage,
      );
    },
    showFirst() {
      return this.currentPage >= 6;
    },
    showLast() {
      return this.totalPages - this.currentPage > 6;
    },
    hasPrev() {
      return this.currentPage > 1;
    },
    hasNext() {
      return this.currentPage < this.totalPages;
    },
  },
  methods: {
    isCurrentPage(page) {
      return page === this.currentPage;
    },
    handleClickPage(page) {
      this.$emit('onPaginate', page);
    },
  },
};
</script>
